import { pageJump } from '@/hooks/useJump';
const pageJump_ = pageJump();
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { projectName } from '@/utils/config';
export default [
  {
    path: '/IFPageTwentyEightPreLogin',
    name: 'PageTwentyEightPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageTwentyEight/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageTwentyEightLogin') {
        pageJump_.jump();
      }
      next();
    },
  },
  {
    path: '/IFPageTwentyEightLogin',
    name: 'PageTwentyEightLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageTwentyEight/login.vue'),
  },
  {
    path: '/IFPageTwentyEightLeaveInfo',
    name: 'PageTwentyEightLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageTwentyEight/leaveInfo.vue'),
  },
  {
    path: '/IFPageTwentyEightResult',
    name: 'PageTwentyEightResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageTwentyEight/result.vue'),
  },
  {
    path: '/IFPageTwentyEightLoading',
    name: 'PageTwentyEightLoading',
    component: () => import('@/pages/pageListAll/pageTwentyEight/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageTwentyEightCar',
    name: 'pageTwentyEightCar',
    component: () => import('@/pages/pageListAll/pageTwentyEight/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageTwentyEightBlank',
    name: 'pageTwentyEightBlank',
    component: () => import('@/pages/pageListAll/pageTwentyEight/blank.vue'),
    meta: {
      title: projectName,
    },
  },
];
